import { useMemo } from "react";
import { useDispatch } from "react-redux";

import useCourseSectionsFetchState from "seneca-common/features/course/hooks/useCourseSectionsFetchState";
import { fetchCoursesDetailsIfNotFetched } from "seneca-common/features/course/service";
import { getCourseSectionIds } from "seneca-common/features/course/state";
import {
  useSelectorOnConditionWithArgs,
  useSelectorWithArgs
} from "seneca-common/utils/hooks/selectors";
import useEffectOnMount from "seneca-common/utils/hooks/useEffectOnMount";

import { getSidebarOpen, toggleSidebar } from "features/classroom/state";
import { getMobileKeyboardOpen } from "features/ui-state/selectors";

export function useSidebarState(courseId: string) {
  const dispatch = useDispatch();
  const { coursesSectionsFinishedFetching: fetchedCourse } =
    useCourseSectionsFetchState(courseId);
  const loadingCourse = !fetchedCourse;
  const mobileKeyboardOpen = useSelectorWithArgs(getMobileKeyboardOpen);
  const opened = useSelectorWithArgs(getSidebarOpen);

  const sectionIdsList = useSelectorOnConditionWithArgs(
    !loadingCourse,
    getCourseSectionIds,
    courseId
  );

  const sectionIds = useMemo(() => {
    return sectionIdsList?.toArray() ?? [];
  }, [sectionIdsList]);

  useEffectOnMount(() => dispatch(fetchCoursesDetailsIfNotFetched()));

  return {
    loadingCourse,
    mobileKeyboardOpen,
    opened,
    toggleSidebar: () => dispatch(toggleSidebar()),
    sectionIds
  };
}
